import { pushDataLayerEvent } from './dataLayer'

let lastPushedCode: string | undefined

/**
 * The referral code a visitor arrived with, sent before the URL is cleaned:
 * GA only learns it from here. Once per code and page load, since effects may
 * run twice.
 */
export function pushPartnerParams(code: string): void {
  if (code === lastPushedCode) {
    return
  }
  lastPushedCode = code
  pushDataLayerEvent({ event: 'partner_params', referral_id: code })
}

export function resetPartnerParamsForTests(): void {
  lastPushedCode = undefined
}
